export function isProductionBuildType() {
  return process.env.NODE_ENV === 'production' && process.env.VUE_APP_QA_ENV === 'false'
}

export function isProductionUrl() {
  return process.env.VUE_APP_IS_PRODUCTION === 'true'
}

export function isStaging() {
  return process.env.VUE_APP_OPERATIONS_BACKEND_URL.includes('staging')
}

export function isQa() {
  return process.env.VUE_APP_QA_ENV === 'true'
}

export function isLocalhost() {
  return (
    process.env.NODE_ENV === 'development' ||
    location?.hostname === 'localhost' ||
    location?.hostname === '127.0.0.1'
  )
}

export function getAppTenant() {
  // TODO: replace VUE_APP_THEME with VUE_APP_TENANT in .env files
  return process.env.VUE_APP_THEME
}

export const TENANT = {
  SENNDER: 'sennder',
  POSTE: 'poste'
}
